export const BRAND_ID = '410E1C07-1205-4EBB-9AFC-2E4BFE1FC192';

// Accent (003) still chats via CommunicationHub/Twilio; all other brands use the omnichannel 1-on-1 chat.
export const ACCENT_BRAND_ID = '4B0C292F-5688-4FAA-9C7B-4431B9F0BE54';

